import { Box, Button, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useLocation, useNavigate } from 'react-router-dom';
import { bodyWidth } from '../../utils/Style';
import { useThemeColor } from '../../hooks/useThemeColor';
import { GenericHelmet } from '../../components/Helmet/GenericHelmet';
import { useLocalizedText } from '../../hooks/useLocalizedText';

export const OrderErrorPage = () => {
  const t = useLocalizedText();

  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const message = queryParams.get('message');

  const { primary, secondary } = useThemeColor();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
      }}
    >
      <GenericHelmet title={t('order_result.error.title')} />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: bodyWidth,
          alignItems: 'center',
          py: 3,
          px: 1.5,
          boxSizing: 'border-box',
        }}
      >
        <ErrorOutlineIcon sx={{ fontSize: 120, color: primary }} />

        <Typography sx={{ fontSize: '40px', fontWeight: 600 }}>
          {t('order_result.error.payment_failed')}
        </Typography>

        <Typography sx={{ fontSize: '24px' }}>
          {message || t('order_result.error.please_check_your_info')}
        </Typography>

        <Button
          onClick={() => navigate('/sepet')}
          variant='contained'
          sx={{
            textTransform: 'none',
            backgroundColor: primary,
            color: secondary,
            mt: 1.5,
          }}
        >
          {t('order_result.error.go_to_basket')}
        </Button>
      </Box>
    </Box>
  );
};
